import { useDebouncedValue } from '@hooks/useDebouncedValue';

/**
 *
 * @param open the intended open state for the dialog
 * @returns a key based on a semi-deferred version of open.
 * Pass the key to dialog's key to reset the dialog on closing,
 * but the delaying allows some time for the UI to animate.
 */
export const useDialogKey = (open: boolean) => {
  const deferredOpen = useDebouncedValue(() => open, 100, [open]);

  return String(open || deferredOpen);
};
